<script>
import { getNewsByTypeIds } from '../../api/news';
import { leftLikeDict } from '../../api/system';
import { findMainProp, formatRelativeOrYMD } from '../../utils';
import Constant from '../../utils/Constant';

export default {
  data() {
    return {
      newsOne: {},
      contentList: [],
      page: 0,
      pageSize: 20,
      // --- 新增状态变量 ---
      loading: false, // 是否正在请求中
      noMore: false,  // 是否已加载完所有数据
    }
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.NEWS_ONE);
      if (res.data) {
        this.newsOne = findMainProp(res.data.data, Constant.NEWS_ONE)
      }
    },

    // --- 修改获取新闻的逻辑 ---
    async getNewsFunc() {
      // 如果正在加载中 或者 没有更多数据了，直接返回，不发送请求
      if (this.loading || this.noMore) return;

      this.loading = true; // 开启加载锁

      try {
        // 10-企业新闻 11-行业干货
        const res = await getNewsByTypeIds([10, 11], {
          page: this.page,
          size: this.pageSize,
        });

        if (res.data && res.data.data && res.data.data.content) {
          const newData = res.data.data.content;

          // 如果返回的数据长度小于 pageSize，说明是最后一页了
          if (newData.length < this.pageSize) {
            this.noMore = true;
          }

          // 如果是第一页，直接赋值；如果是后续页，进行数组拼接
          if (this.page === 0) {
            this.contentList = newData;
          } else {
            this.contentList = [...this.contentList, ...newData];
          }

          // 页码 +1，为下一次请求做准备
          if (newData.length > 0) {
            this.page++;
          }
        } else {
          // 异常情况视为没有更多
          this.noMore = true;
        }
      } catch (error) {
        console.error('加载失败', error);
      } finally {
        this.loading = false; // 关闭加载锁
      }
    },

    // --- 新增滚动监听处理函数 ---
    handleScroll() {
      // 获取滚动高度、可视窗口高度、文档总高度
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 距离底部 50px 时触发加载 (增加一点缓冲)
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.getNewsFunc();
      }
    },

    openNew(id) {
      if (this.$router && this.$router.resolve) {
        const routeData = this.$router.resolve({ path: '/news_detail/' + id });
        window.open(routeData.href, '_blank');
      }
    },
    formatRelativeOrYMD(dateStr) {
      return formatRelativeOrYMD(dateStr)
    }
  },
  mounted() {
    this.leftLikeDictFunc()
    this.getNewsFunc()
    // --- 添加滚动监听 ---
    window.addEventListener('scroll', this.handleScroll);
  },
  // --- 记得销毁监听，防止内存泄漏 ---
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<template>
  <div class="news_wrap">
    <div class="news_img" :style="{ background: `url(${newsOne.image}) 0 0 no-repeat`, backgroundSize: '100%' }">
      <div class="img_tit">{{ newsOne.title }}</div>
      <div class="img_desc">{{ newsOne.subtitle }}</div>
    </div>

    <div class="container">
      <h2 class="section-title">最新资讯</h2>

      <div class="news-grid">
        <article class="news-card" v-for="item in contentList" :key="item.id" @click="openNew(item.id)">
          <img :src="item.image" :alt="item.title" class="card-image" />
          <div class="card-content">
            <span class="card-tag">{{ item.type.typeName }}</span>
            <h3 class="card-title">{{ item.title }}</h3>
            <p class="card-desc">
              {{ item.subTitle }}
            </p>
            <div class="card-meta">
              <span>{{ item.author || '匿名' }}</span>
              <span>{{ formatRelativeOrYMD(item.createTime) }}</span>
            </div>
          </div>
        </article>
      </div>

      <div class="footer-status">
        <div v-if="loading" class="loading-box">
          <span class="loading-icon"></span> 努力加载中...
        </div>
        <div v-if="noMore && contentList.length > 0" class="no-more-line">
          <span>已显示全部内容</span>
        </div>
        <div v-if="noMore && contentList.length === 0" class="empty-box">
          暂无资讯
        </div>
      </div>

    </div>
  </div>
</template>
<style lang="scss" scoped>
.news_wrap {
  width: 100%;

  .news_img {
    width: 100%;
    height: 450px;

    @media screen and (max-width: 768px) {
      height: 50vw;
    }

    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 54px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    .img_desc {
      font-size: 28px;
      margin-top: 20px;

      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  /* --- 底部状态美化样式 --- */
  .footer-status {
    padding: 40px 0 20px;
    text-align: center;
    color: #909399;
    font-size: 13PX;

    /* 加载中动画 */
    .loading-box {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      .loading-icon {
        width: 14px;
        height: 14px;
        border: 2px solid #e0e0e0;
        border-top-color: #3498db;
        /* 你的主题色 */
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
      }
    }

    /* 到底了 - 分割线样式 */
    .no-more-line {
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.6;

      span {
        padding: 0 15px;
        position: relative;
      }

      /* 利用伪元素画线 */
      &::before,
      &::after {
        content: '';
        width: 60px;
        /* 线条长度 */
        height: 1px;
        background-color: #dcdfe6;
        display: block;
      }
    }
  }

  /* 旋转动画 */
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .container {
    max-width: 1100px;
    margin: 40px auto;
    padding: 0 20PX;

    @media screen and (max-width: 768px) {
      max-width: 100%;
    }
  }

  .section-title {
    font-size: 1.5rem;
    margin-bottom: 30px;
    padding-left: 15px;
    border-left: 5PX solid #3498db;
    /* 左侧装饰线 */
    color: #2c3e50;
  }

  /* --- 新闻卡片网格布局 --- */
  .news-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    /* 自动适应列宽 */
    gap: 20PX;

    @media screen and (max-width: 768px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  /* --- 单个新闻卡片 --- */
  .news-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 4PX 6PX rgba(0, 0, 0, 0.05);
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }

  .news-card:hover {
    transform: translateY(-5px);
    /* 悬浮上浮效果 */
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1);
  }

  .card-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
    background-color: #eee;

    @media screen and (max-width: 768px) {
      height: 200PX;
    }
  }

  .card-content {
    padding: 20PX;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .card-tag {
    font-size: 0.75rem;
    color: #3498db;
    font-weight: 600;
    margin-bottom: 8PX;
    text-transform: uppercase;
  }

  .card-title {
    font-size: 1.1rem;
    font-weight: 700;
    margin-bottom: 10PX;
    color: #2c3e50;
    line-height: 1.4;
  }

  .card-desc {
    font-size: 0.9rem;
    color: #7f8c8d;
    margin-bottom: 20PX;
    flex-grow: 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }

  .card-meta {
    font-size: 0.8rem;
    color: #95a5a6;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #f1f1f1;
    padding-top: 15PX;
  }
}
</style>